import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/header';
import Policy from './policies';
import Whistleblower from './whistleblower';

import { useLanguage } from '../../helpers/language-context';

const Governance = () => {
  const { translations } = useLanguage();
  const [activeSection, setActiveSection] = useState('policy');
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#whistleblowing') {
      setActiveSection('whistleblower');
    } else if (location.hash === '#corporate') {
      setActiveSection('corporate');
    } else if (location.hash === '#policy') {
      setActiveSection('policy');
    }
  }, [location.hash]);

  return (
    <div className="ourbrand-container">
      <Header title={translations.navbar.governance} flip={true} bgImg="/assets/images/header-bg/bg_governance.png" />
      <section className="bg-white text-black space-y-16">
        <div className="flex flex-wrap justify-center items-center gap-4">
          <button
            onClick={() => setActiveSection('policy')}
            className={`px-6 py-2 rounded-full font-medium transition-colors border-2 border-[#28357B] ${activeSection === 'policy'
                ? 'bg-[#28357B] text-white'
                : 'bg-white text-[#28357B]'
              }`}
          >
            {translations.governance.policy}
          </button>
          <button
            onClick={() => setActiveSection('whistleblower')}
            className={`px-6 py-2 rounded-full font-medium transition-colors border-2 border-[#28357B] ${activeSection === 'whistleblower'
                ? 'bg-[#28357B] text-white'
                : 'bg-white text-[#28357B] hover:bg-gray-50'
              }`}
          >
            {translations.governance.whistleblowerPolicy}
          </button>
        </div>
      </section>

      {/* Conditional rendering based on active section */}
      {activeSection === 'policy' && <Policy />}
      {activeSection === 'whistleblower' && <Whistleblower />}
    </div>
  );
};

export default Governance;
